/**
 * Offers Module
 */

class OffersList {
  #element;
  #cards;
  #infoMessage;

  /**
   * @constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor(element) {
    this.#element = element;
    this.#cards = this.#element.querySelectorAll('a.card');
    this.#infoMessage = document.querySelector('.js-info-message');

    this.#bindEvents();
  }

  /**
   * Binds the necessary event listeners
   */
  #bindEvents() {
    this.#cards.forEach(card => {
      card.addEventListener('click', this.#handleCardClick.bind(this));
    });

    const closeButton = this.#infoMessage?.querySelector('.info-message__close');
    if (closeButton) {
      closeButton.addEventListener('click', this.#handleInfoMessageClose.bind(this));
    }
  }

  /**
   * Removes the "campaign" query parameter from the current page URL
   * and removes the info message element if present
   */
  #removeCampaignParamFromCurrentUrl() {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete('campaign');
    window.history.replaceState(null, '', urlObj.toString());

    this.#infoMessage?.remove();
  }

  /**
   * Handles the click event on the info message close button
   * @param {Event} event - The click event
   */
  #handleInfoMessageClose(event) {
    event.preventDefault();
    this.#removeCampaignParamFromCurrentUrl();
  }

  /**
   * Handles the click event on a card link
   * @param {Event} event - The click event
   */
  #handleCardClick(event) {
    if (event.metaKey || event.ctrlKey) {
      return;
    }

    event.preventDefault();

    const card = event.currentTarget;
    this.#removeCampaignParamFromCurrentUrl();

    window.location.href = card.href;
  }

  static init() {
    const offersLists = document.querySelectorAll('.js-offers-list');

    offersLists.forEach(el => {
      new OffersList(el);
    });
  }
}

export default OffersList;
